module.exports = __webpack_public_path__ + "img/default-member.39dd3a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default-member.png
// module id = rA+B
// module chunks = 1